import { render, staticRenderFns } from "./enterprise-origin-toggle.vue?vue&type=template&id=fe3faf30&"
import script from "./enterprise-origin-toggle.vue?vue&type=script&lang=js&"
export * from "./enterprise-origin-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports